import { makeStyles } from '@material-ui/styles';
import { inputColors } from '../../modules/material-ui-kit/material-kit-pro-react';
import { styleVariables } from '../../modules/employer/position-wizard/create/EmployerJobWizardCreateStyle';
import {
    white, alabaster, black, royalblue,
} from '../../constants/Colors';

const editorMarginPx = 8;

const textEditorStyles = makeStyles((theme) => ({
    container: {},
    labelText: {
        color: black,
        fontSize: 15,
        fontWeight: 300,
        paddingLeft: '10px',
        transform: `translate(0, -6px) scale(${styleVariables.inputLabelShrinkScaleFactor})`,
        transformOrigin: 'top left',
    },
    editorContainer: {
        border: ({ error }) => (error
            ? `2px solid ${inputColors.error.borderColor}`
            : `1px solid${inputColors.default.borderColor}`
        ),
        backgroundColor: white,
        '&:focus-within, &:active': {
            border: ({ error, disableFocus }) => {
                if (disableFocus && !error) {
                    return 'none';
                }

                return error
                    ? `2px solid ${inputColors.error.borderColor}`
                    : `1px solid${inputColors.active.borderColor}`;
            },
        },
        boxSizing: 'border-box',
        height: ({ fullHeight }) => (fullHeight ? '100%' : 'auto'),
        display: 'flex',
        flexDirection: 'column',
        '& a:not(.MuiButton-root)': {
            color: theme?.links?.primary?.textColor || royalblue,
        },
    },
    editor: {
        padding: '8px',
        paddingRight: ({ isCopyIconPresent }) => (isCopyIconPresent ? '60px' : '8px'),
        maxHeight: ({
            lines, maxHeight, fullHeight, lineHeight,
        }) => {
            if (fullHeight) {
                // return '100%';
                return '';
            }

            if (maxHeight) {
                return `${maxHeight - (2 * editorMarginPx)}px`;
            }

            return lines
                ? `${lineHeight * lines}px`
                : 'none';
        },
        height: ({
            lines, maxHeight, fullHeight, lineHeight,
        }) => {
            if (fullHeight) {
                return '100%';
            }

            if (maxHeight) {
                return `${maxHeight - (2 * editorMarginPx)}px`;
            }

            return lines
                ? `${lineHeight * lines}px`
                : 'auto';
        },
        lineHeight: ({ lineHeight }) => `${lineHeight - 4}px`,
        overflowY: 'auto',
    },
    resizeHandle: {
        height: '7px !important',
        bottom: '0px !important',
        borderTop: '1px solid',
        borderColor: inputColors.default.borderColor,
        paddingTop: '1px',
        cursor: 'ns-resize !important',
        backgroundColor: alabaster,
        margin: ({ maxHeight }) => {
            if (!maxHeight) {
                return `0 0 -${editorMarginPx}px 0`;
            }
            return '0';
        },
        '&:before': {
            top: '3px',
            width: '6%',
            height: '1px',
            content: '""',
            display: 'block',
            position: 'absolute',
            background: inputColors.default.borderColor,
            margin: '0 47%',
        },
        '&:after': {
            top: '5px',
            width: '6%',
            height: '1px',
            content: '""',
            display: 'block',
            position: 'absolute',
            background: inputColors.default.borderColor,
            margin: '0 47%',
        },
    },
}));

export default textEditorStyles;
